;(function () {
	const swiperInstances = new Map()

	const toBoolean = (value) => value === 'true' || value === true

	const getOpenRecensioneCompleta = (sliderRoot) => {
		const sectionId = sliderRoot.dataset.id
		if (!sectionId) return null

		return document.querySelector(
			`modal-dialog.testimonials__recensione-completa[open][data-testimonials-id="${sectionId}"]`
		)
	}

	const lockSlider = (sliderRoot, locked) => {
		const swiper = swiperInstances.get(sliderRoot.dataset.id)
		if (!swiper) return

		swiper.allowTouchMove = !locked
		swiper.allowSlideNext = !locked
		swiper.allowSlidePrev = !locked

		if (locked) {
			if (swiper.autoplay?.stop) swiper.autoplay.stop()
			return
		}

		if (swiper.autoplay?.start && toBoolean(sliderRoot.dataset.autoplay)) {
			swiper.autoplay.start()
		}
	}

	const pauseSliderForModal = (sliderRoot) => {
		if (!sliderRoot) return
		sliderRoot.classList.add('is-recensione-completa-open')
		lockSlider(sliderRoot, true)
	}

	const resumeSliderIfIdle = (sliderRoot) => {
		if (!sliderRoot || getOpenRecensioneCompleta(sliderRoot)) return
		sliderRoot.classList.remove('is-recensione-completa-open')
		lockSlider(sliderRoot, false)
	}

	const syncQuoteOverflow = (sliderRoot) => {
		sliderRoot.querySelectorAll('[data-quote-block]').forEach((block) => {
			const text = block.querySelector('[data-quote-text]')
			const toggle = block.querySelector('[data-quote-toggle]')
			if (!text || !toggle) return

			const overflows = text.scrollHeight > text.clientHeight + 1
			toggle.classList.toggle('hidden', !overflows)
		})
	}

	const destroySlider = (sectionId, sliderRoot) => {
		const swiperEl = sliderRoot.querySelector('.testimonials__swiper')
		const swiper = swiperInstances.get(sectionId)
		if (swiper && typeof swiper.destroy === 'function') {
			swiper.destroy(true, true)
			swiperInstances.delete(sectionId)
		}
		if (swiperEl) {
			swiperEl.classList.remove('swiper-initialized')
		}
		sliderRoot.classList.remove('is-recensione-completa-open')
	}

	const initSlider = (sliderRoot) => {
		const sectionId = sliderRoot.dataset.id
		if (!sectionId || swiperInstances.has(sectionId)) return

		const swiperEl = sliderRoot.querySelector('.testimonials__swiper')
		if (!swiperEl || typeof Swiper === 'undefined') return

		const blockCount = +sliderRoot.dataset.blockCount
		if (blockCount <= 1) {
			requestAnimationFrame(() => syncQuoteOverflow(sliderRoot))
			return
		}

		const speed = +sliderRoot.dataset.speed * 1000
		const delay = +sliderRoot.dataset.delay * 1000
		const autoplay = toBoolean(sliderRoot.dataset.autoplay)
		const stopAutoplay = toBoolean(sliderRoot.dataset.stopAutoplay)

		let autoplayParam = {}
		if (autoplay) {
			autoplayParam = {
				autoplay: {
					delay,
					pauseOnMouseEnter: stopAutoplay,
					disableOnInteraction: false,
				},
			}
		}

		const swiper = new Swiper(swiperEl, {
			speed,
			slidesPerView: 'auto',
			slidesPerGroup: 1,
			spaceBetween: 32,
			loop: true,
			autoHeight: false,
			keyboard: true,
			breakpoints: {
				750: {
					spaceBetween: 80,
				},
				990: {
					spaceBetween: 129,
				},
			},
			navigation: {
				nextEl: `#${sectionId} .testimonials__nav .swiper-button-next`,
				prevEl: `#${sectionId} .testimonials__nav .swiper-button-prev`,
			},
			pagination: {
				el: `#${sectionId} .testimonials__counter`,
				type: 'custom',
				renderCustom: function (_swiper, current, total) {
					return current + ' - ' + total
				},
			},
			on: {
				init: () => {
					requestAnimationFrame(() => syncQuoteOverflow(sliderRoot))
				},
			},
			...autoplayParam,
		})

		swiperInstances.set(sectionId, swiper)
	}

	const syncSlider = (sliderRoot) => {
		const sectionId = sliderRoot.dataset.id
		if (!sectionId) return

		destroySlider(sectionId, sliderRoot)
		initSlider(sliderRoot)
	}

	const initTestimonials = () => {
		document.querySelectorAll('.testimonials').forEach((sliderRoot) => {
			syncSlider(sliderRoot)
		})
	}

	document.addEventListener('click', (event) => {
		const toggle = event.target.closest('[data-quote-toggle]')
		if (!toggle) return

		const sliderRoot = toggle.closest('.testimonials')
		if (sliderRoot) pauseSliderForModal(sliderRoot)
	})

	document.body.addEventListener('modalClosed', () => {
		document.querySelectorAll('.testimonials').forEach((sliderRoot) => {
			resumeSliderIfIdle(sliderRoot)
		})
	})

	initTestimonials()

	document.addEventListener('shopify:section:load', initTestimonials)
	document.addEventListener('shopify:section:unload', (event) => {
		const sliderRoot = event.target.querySelector('.testimonials')
		if (!sliderRoot) return
		destroySlider(sliderRoot.dataset.id, sliderRoot)
	})

	let resizeTimer
	window.addEventListener('resize', () => {
		clearTimeout(resizeTimer)
		resizeTimer = setTimeout(initTestimonials, 150)
	})
})()
